import fetch from '@/utils/fetch';

//小程序码
export function getQrcode(data) {
  return fetch({
    url: '/saas/user/w/wechat/qrcode/create',
    method: 'post',
    data,
  });
}
